import { mockDataUtil } from './mockDataUtil';
import { storeItemSaleList } from '../mock/storeItemSaleData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import httpClient from './httpClient';
import { 
  StoreItemSale, 
  StoreItemSaleFilters, 
  StoreItemSalePaginationParams,
  ApiResponse,
  StoreItemSalePageData
} from '../types/store-item-sale';
import { WHOLE_USE_MOCK } from './api';

class StoreItemSaleService {
// 是否使用模拟数据
  async getMock(): Promise<boolean> {
    return true;
  }

  /**
   * 获取门店商品销量分页列表
   * @param filters 过滤条件
   * @param paginationParams 分页参数
   * @returns 分页数据
   */
  async getStoreItemSales(
    filters: StoreItemSaleFilters = {},
    paginationParams: StoreItemSalePaginationParams
  ): Promise<ApiResponse<StoreItemSalePageData>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      let filteredData = [...storeItemSaleList];

      // 应用过滤条件
      if (filters.storeCode) {
        filteredData = filteredData.filter(item => 
          item.storeCode.toLowerCase().includes(filters.storeCode!.toLowerCase())
        );
      }

      if (filters.itemCode) {
        filteredData = filteredData.filter(item => 
          item.itemCode.toLowerCase().includes(filters.itemCode!.toLowerCase())
        );
      }

      if (filters.ownerCode) {
        filteredData = filteredData.filter(item => 
          item.ownerCode.toLowerCase().includes(filters.ownerCode!.toLowerCase())
        );
      }

      if (filters.creatorAccount) {
        filteredData = filteredData.filter(item => 
          item.creatorAccount.toLowerCase().includes(filters.creatorAccount!.toLowerCase())
        );
      }

      if (filters.gmtCreateStart) {
        filteredData = filteredData.filter(item => 
          item.gmtCreate >= filters.gmtCreateStart!
        );
      }

      if (filters.gmtCreateEnd) {
        filteredData = filteredData.filter(item => 
          item.gmtCreate <= filters.gmtCreateEnd!
        );
      }

      // 应用排序
      if (paginationParams.sortBy && paginationParams.sortOrder) {
        filteredData.sort((a, b) => {
          const field = paginationParams.sortBy!;
          let aValue = a[field];
          let bValue = b[field];

          // 处理不同类型的字段排序
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }

          if (paginationParams.sortOrder === 'asc') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
          } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
          }
        });
      }

      // 应用分页
      const startIndex = (paginationParams.currentPage - 1) * paginationParams.pageSize;
      const endIndex = startIndex + paginationParams.pageSize;
      const paginatedData = filteredData.slice(startIndex, endIndex);

      const response = await mockDataUtil.mockPageRes(paginatedData, {
        currentPage: paginationParams.currentPage,
        totalCount: filteredData.length,
        pageSize: paginationParams.pageSize
      });

      return response as unknown as ApiResponse<StoreItemSalePageData>;
    } else {
      const searchParams = {
        ...filters,
        ...paginationParams
      };
      const res = await httpClient.post(API_ENDPOINTS.STORE_ITEM_SALE.PAGE, searchParams);
      return res.data;
    }
  }
}

export const storeItemSaleService = new StoreItemSaleService();